import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import { useSelector } from 'react-redux';
import tokenStorage from 'utils/tokenStorage';

const PublicTelephonyReportPage = React.lazy(
	() => import('views/app-views/dashboards/reports/PublicTelephonyReportPage')
);

// Component to handle role-based redirect
const RoleBasedRedirect = () => {
	const { role } = useSelector(state => state.auth);
	const normalizedRole = (role || tokenStorage.getItem('user_role') || '').toLowerCase();
	let redirectPath;

	if (normalizedRole === 'agent') {
		redirectPath = `${APP_PREFIX_PATH}/agent/dashboard`;
	} else if (normalizedRole === 'client') {
		redirectPath = `${APP_PREFIX_PATH}/client/dashboard`;
	} else if (normalizedRole === 'admin') {
		redirectPath = `${APP_PREFIX_PATH}/dashboards/admin`;
	} else if (normalizedRole === 'manager' || normalizedRole === 'staff') {
		// Manager & staff partagent le même dashboard user
		redirectPath = `${APP_PREFIX_PATH}/dashboards/user`;
	} else {
		// Default fallback
		redirectPath = `${APP_PREFIX_PATH}/dashboards/user`;
	}

	return <Navigate replace to={redirectPath} />;
};

const Routes = () => {

	return (
		<RouterRoutes>
			<Route
				path="/public/reports/:token"
				element={
					<AppRoute
						routeKey="public-telephony-report"
						component={PublicTelephonyReportPage}
						blankLayout
					/>
				}
			/>
			{/* Routes publiques en premier pour éviter les conflits */}
			<Route path="/" element={<PublicRoute />}>
				{/* Par défaut, rediriger vers la page de login publique */}
				<Route index element={<Navigate to="/auth/login" replace />} />
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>
			{/* Routes protégées après les routes publiques */}
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<RoleBasedRedirect />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
		</RouterRoutes>
	)
}

export default Routes